import EventEmitter from '../../../utils/event-emitter';

import TRANSCODING from './types/transcoding';
import FILE from './types/file';
import ITEM from './types/item';
import ITEMS from './types/items';
import LIST from './types/list';
import LIST_ITEMS from './types/list-items';
import LISTS from './types/lists';
import PREMIUM from './types/premium';
import UPLOADING_PROGRESS from './types/uploading-progress';

function wrapWithRequestStates(eventsGroups) {
  return _.mapValues(eventsGroups, function (eventsByNames) {
    return _.mapValues(eventsByNames, function (event) {
      return {
        BEFORE: `${event}.BEFORE`,
        SUCCESS: `${event}.SUCCESS`,
        FAIL: `${event}.FAIL`,
      };
    });
  });
}

const requestEvents = {
  FILE,
  ITEM,
  ITEMS,
  LIST,
  LIST_ITEMS,
  LISTS,
  PREMIUM,
};

export default _.assign(new EventEmitter(), {
  TRANSCODING,
  UPLOADING_PROGRESS,
}, wrapWithRequestStates(requestEvents));



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/events/index.js